"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToCodes = exports.objectFromCode = exports.productToOldBarcode = exports.formatToCode = void 0;
const errors_1 = require("@wolf/errors");
const dates_1 = require("@wolf/dates");
const box_1 = require("./box");
const product_1 = require("./product");
const types_1 = require("./types");
const customer_1 = require("./customer");
const formatToCode = (value) => {
    if (typeof value === 'number') {
        return value.toString().padStart(2, '0');
    }
    const date = new Date(value.setMonth(value.getMonth() - 1));
    return (0, dates_1.format)(date, 'ddMMyyHHmm');
};
exports.formatToCode = formatToCode;
const productToOldBarcode = (product) => {
    const formattedProductId = product.productId.toString().padStart(5, '0');
    const formattedDate = (0, dates_1.format)(product.date, 'ddHHmm');
    const formattedIndex = product.index.toString().padStart(4, '0');
    return `${formattedProductId}${formattedDate}${formattedIndex}`;
};
exports.productToOldBarcode = productToOldBarcode;
const decodeOldBarcode = (barcodeText) => {
    // Extract the index (last 4 characters)
    const index = barcodeText.slice(-4);
    // Extract the date (6 characters in the format 'ddHHmm')
    const date = barcodeText.slice(-10, -4);
    // The remaining part is the productId
    const productId = barcodeText.slice(0, -10);
    return {
        productId: Number(productId),
        date: Number(date),
        index: Number(index)
    };
};
const objectFromCode = (code) => {
    try {
        const codes = (0, exports.stringToCodes)(code);
        if ('productId' in codes) {
            return codes;
        }
        if (codes[0].value === types_1.type.box) {
            return (0, box_1.boxFromCode)(code);
        }
        if (codes[0].value === types_1.type.customer) {
            return (0, customer_1.customerFromCode)(code);
        }
        if (codes[0].value === types_1.type.product) {
            return (0, product_1.productFromCode)(code);
        }
        if (codes[0].value === types_1.type.productV2) {
            return (0, product_1.productFromCode)(code);
        }
        throw new errors_1.BadRequestError(errors_1.BAD_REQUEST_ERROR_CODES.BAD_PICKING_INPUT, 'Invalid type value');
    }
    catch (error) {
        throw new errors_1.ApplicationError(`${error}`);
    }
};
exports.objectFromCode = objectFromCode;
const cleanCode = (code) => {
    //  Dpd code starts with [)> characters
    if (!code.startsWith('[)>'))
        return code;
    const regex = /\(\d+\)[^#]*#/g;
    const selectedCode = code.trim().match(regex);
    const cleanedCode = selectedCode
        ? selectedCode.map(c => c.replace('#', '').replace(/\s+/g, ''))
        : [];
    const cleanedCodeWithoutDuplicated = new Set(cleanedCode);
    const formatCode = Array.from(cleanedCodeWithoutDuplicated).sort((a, b) => {
        if (a.startsWith(types_1.typeIA))
            return -1;
        if (b.startsWith(types_1.typeIA))
            return 1;
        return 0;
    });
    return formatCode.join('');
};
const stringToCodes = (code) => {
    const codeCleaned = cleanCode(code);
    const codes = codeCleaned.match(/(\(\d+\)\d+)/g)?.map((group) => {
        const [code, value] = group.match(/\d+/g) || [];
        return {
            code,
            value,
        };
    });
    if (!codes) {
        try {
            const barcodeObject = decodeOldBarcode(code);
            if (isNaN(barcodeObject.index) || isNaN(barcodeObject.date) || isNaN(barcodeObject.productId)) {
                throw new Error(`Invalid format code ${code}`);
            }
            return barcodeObject;
        }
        catch {
            throw new errors_1.BadRequestError(errors_1.BAD_REQUEST_ERROR_CODES.BAD_PICKING_INPUT, 'Incorrect format');
        }
    }
    return codes;
};
exports.stringToCodes = stringToCodes;
//# sourceMappingURL=utils.js.map